<template>
    <div>
        <div class="tool-status">
            <!-- <div class="card w-150"> -->
            <b-card class="text-left">
                <!-- <div class="card-text"> -->
                <div class="row alert alert-info" v-if="!!accessPoint">
                    <div class="col-12">
                        <h5>{{ accessPoint.name }}</h5>
                    </div>
                </div>
                <!-- <div class="row" v-if="accessPoints.length === 0">
                            <div class="col-12 alert alert-danger">
                                <h5>No se puede {{ isStart? 'Iniciar': 'Finalizar' }} turno porque no hay puntos de acceso configurados en el cliente. <br>Contacte al administrador</h5>
                            </div>
                </div>-->
                <div class="row" v-if="accessPoints.length > 0 && isOther">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="access-point">Punto de acceso</label>
                            <select
                                name="access-point"
                                id="access-point"
                                class="form-control"
                                v-model="theAccessPoint"
                                @change="setLastShift()"
                            >
                                <option v-if="accessPoints.length > 1" value>
                                    -- Seleccione --
                                </option>
                                <option
                                    v-for="ap in accessPoints"
                                    :value="ap"
                                    :key="ap.id"
                                >
                                    {{ ap.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <b-row>
                    <b-col cols="12" md="4">
                        <label>Labor del Turno</label>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="form-group row">
                            <div class="col-4">
                                <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="..."
                                >
                                    <button
                                        class="btn"
                                        v-for="rol in vigilanceRoles"
                                        :key="rol.id"
                                        @click="shift.vigilanceRol = rol.id"
                                        :class="{
                                            'btn-success':
                                                rol.id === shift.vigilanceRol,
                                            'btn-secondary':
                                                rol.id !== shift.vigilanceRol,
                                        }"
                                    >
                                        {{ rol.name }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <!-- Left Panel -->
                    <b-col cols="12">
                        <b-row>
                            <b-col md="4">
                                <strong>Herramienta</strong>
                            </b-col>
                            <b-col md="4">
                                <strong>Serial</strong>
                            </b-col>
                            <!-- <b-col md="3">
                                <strong>Número</strong>
                                <span class="field-required-mark">*</span>
                            </b-col> -->
                            <b-col md="4">
                                <strong>Estado</strong>
                                <span class="field-required-mark">*</span>
                            </b-col>
                            <!-- <div v-if="toolIssues" class="col-4 col-sm-3"><strong>Observaciones</strong><span class="field-required-mark">*</span></div> -->
                        </b-row>
                        <h5 class="text-muted" v-if="!items.length">
                            No hay herramientas por validar
                        </h5>

                        <b-row v-for="item in items" :key="item.id">
                            <b-col md="4">
                                <ul>
                                    <li class="ml-4" type="square">
                                        <label>{{
                                            !!item.item_sub_type
                                                ? item.item_sub_type.name
                                                : item.item_type.name
                                        }}</label>
                                    </li>
                                </ul>
                            </b-col>
                            <b-col md="4">
                                <label>{{
                                    !!item.serial ? item.serial : 'Sin serial'
                                }}</label>
                            </b-col>
                            <!-- <b-col md="3"> -->
                            <!-- <div class="col-4 col-sm-3"> -->
                            <!-- <input
                                    type="text"
                                    class="form-control"
                                    :value="getReference(item.id)"
                                    @change="
                                                setNumber(
                                                    item.id,
                                                    $event.target.value
                                                )
                                            "
                                /> -->
                            <!-- </div> -->
                            <!-- </b-col> -->
                            <b-col md="4" class="mt-2">
                                <!-- <div class="col-4 col-sm-3"> -->
                                <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="..."
                                >
                                    <button
                                        v-for="status in toolStatuses"
                                        :key="status.id"
                                        @click="setStatus(item.id, status.id)"
                                        class="btn btn-sm"
                                        :class="{ 'btn-success': isStatusSelected( item.id, status.id ) && status.name == 'Bueno', 'btn-danger': isStatusSelected( item.id, status.id ) && status.name == 'Malo', 'btn-warning': isStatusSelected( item.id, status.id ) && status.name == 'Regular', 'btn-secondary': !isStatusSelected( item.id, status.id ), }"
                                    >
                                        {{ status.name }}
                                    </button>
                                </div>
                                <!-- </div> -->
                                <div class="col-12" v-if="toolIssue(item.id)">
                                    <div class="form-group">
                                        <label
                                            class="control-label"
                                            :for="item.id"
                                        >
                                            Observaciones
                                            <span class="field-required-mark"
                                                >*</span
                                            >
                                        </label>
                                        <input
                                            type="text"
                                            :id="item.id"
                                            class="form-control should-fill"
                                            @input="
                                                setNotes(
                                                    item.id,
                                                    $event.target.value
                                                )
                                            "
                                        />
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- End left panel -->
                </b-row>
                <b-row>
                    <b-col>
                        <hr class="mt-3" />
                        <h4>
                            Lista de Chequeo
                            <span class="field-required-mark">*</span>
                        </h4>
                    </b-col>
                </b-row>
                <b-row class="mt-3" v-if="questions.length > 0">
                    <b-col class="ml-4">
                        <ul
                            v-for="question in questions"
                            :key="question.id"
                            class="form-group row"
                        >
                            <b-col cols="7">
                                <li type="square">
                                    {{ question.name }}
                                </li>
                            </b-col>

                            <b-col cols="3">
                                <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="Basic example"
                                >
                                    <button
                                        type="button"
                                        :title="answer.description"
                                        @click="
                                            setAnswer(question.id, answer.id)
                                        "
                                        :key="`answer_${question.id}_${answer.id}`"
                                        :id="`answer_${question.id}_${answer.id}`"
                                        class="btn btn-sm"
                                        :class="{
                                            'btn-secondary': !isSelected(
                                                question.id,
                                                answer.id
                                            ),
                                            'btn-success': isSelected(
                                                question.id,
                                                answer.id
                                            ),
                                        }"
                                        v-for="answer in answerTypes"
                                    >
                                        {{ answer.name }}
                                    </button>
                                </div>
                            </b-col>
                        </ul>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12">
                        <b-alert variant="warning" show
                            >No hay Items por validar</b-alert
                        >
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <b-col>
                        <div class="form-group">
                            <label for="notes">Notas</label>
                            <textarea
                                name="notes"
                                id="notes"
                                cols="10"
                                rows="5"
                                class="form-control"
                                v-model="shift.notes"
                            ></textarea>
                        </div>
                        <div class="errors" v-if="errors.length > 0">
                            <h2>
                                <span class="field-error">Errores</span>
                            </h2>
                            <ul>
                                <li
                                    class="ml-3"
                                    v-for="error in errors"
                                    :key="error.id"
                                >
                                    <b-alert show variant="danger">{{
                                        error
                                    }}</b-alert>
                                </li>
                            </ul>
                        </div>
                        <div class="button">
                            <button
                                class="btn btn-confirm pull-right"
                                @click="startShift"
                            >
                                {{ isStart ? 'Iniciar' : 'Entregar' }}
                                Turno
                            </button>
                        </div>
                    </b-col>
                </b-row>
                <!-- </div> -->
            </b-card>
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
import shiftsRepository from '../../../../repositories/shifts.repository'
import { mapGetters } from 'vuex'
export default {
    // props: ['isOther'],
    props: {
        isStart: {
            default: true,
        },
        isOther: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            shift: {
                answers: [],
                vigilanceRol: '',
                notes: '',
                statuses: [],
            },
            theAccessPoint: '',
            questions: [],
            answerTypes: [],
            errors: [],
            vigilanceRoles: [],
            items: [],
            toolStatuses: [],
            lastShifts: [],
            isOthers: false,
        }
    },
    computed: {
        // ...mapGetters(['structures', 'accessPoint', 'shift']),
        ...mapGetters({
            structures: 'structures',
            accessPoint: 'accessPoint',
            currentShift: 'shift',
        }),
        accessPoints() {
            return this.structures.filter(
                (item) => !!item.structure_type.access_point
            )
        },
        // toolIssuesitem        //     return !!this.shift.statuses.filter(item => this.dangerStatuses.includes(item.statusId)).length;
        // },
        dangerStatuses() {
            return this.toolStatuses
                .filter((item) => item.name.toLowerCase() !== 'bueno')
                .map((item) => item.id)
        },
    },
    methods: {
        setLastShift() {
            this.shift.answers = []
            this.shift.vigilanceRol = ''
            this.shift.notes = ''
            this.shift.statuses = []

            this.$store.commit('accessPoint', this.theAccessPoint)
            this.loadMasterData()
        },
        getLastStatusesShift(shift) {
            this.items.map((item) => {
                const itemStatus = shift.shift_item_statuses.find(
                    (itemStat) =>
                        !itemStat.supervision && itemStat.item_id === item.id
                )
                // this.setNumber(
                //     item.id,
                //     !!itemStatus ? itemStatus.reference : ''
                // )
                this.setStatus(
                    item.id,
                    !!itemStatus ? itemStatus.item_status_id : ''
                )
            })
            // shift.shift_tool_statuses.filter(item => !item.supervision).map(item => {
            //     this.setNumber(item.tool_id, item.reference);
            //     this.setStatus(item.tool_id, item.tool_status_id);
            // })
        },
        async loadMasterData() {
            const structureId = !!this.accessPoint ? this.accessPoint.id : ''
            const { data } = await repo.get( `vigilance/client/${this.client.id}/load-shift-data`, { structureId } )
            this.questions = data.questions
            this.answerTypes = data.answers
            this.vigilanceRoles = data.roles
            this.items = data.items
            this.toolStatuses = data.itemStatuses
            if (!!data.lastShift && !!data.lastShift.shift_item_statuses) {
                this.getLastStatusesShift(data.lastShift)
            }
        },
        setNotes(toolId, notes) {
            const index = this.shift.statuses.findIndex(
                (item) => item.toolId === toolId
            )
            const status = Object.assign({}, this.shift.statuses[index], {
                notes,
            })
            this.shift.statuses.splice(index, 1, status)
        },
        getReference(toolId) {
            const status = this.shift.statuses.find(
                (item) => item.toolId === toolId
            )
            return !!status ? status.reference : ''
        },
        setAnswer(questionId, answerId) {
            const index = this.shift.answers.findIndex(
                (item) => item.questionId === questionId
            )
            const answer =
                -1 !== index
                    ? Object.assign({}, this.shift.answers[index], { answerId })
                    : { questionId, answerId }
            if (-1 === index) {
                this.shift.answers.push(answer)
            } else {
                this.shift.answers.splice(index, 1, answer)
            }
        },
        isSelected(questionId, answerId) {
            return !!this.shift.answers.find(
                (item) =>
                    item.questionId === questionId && item.answerId === answerId
            )
        },
        isStatusSelected(toolId, statusId) {
            return !!this.shift.statuses.find(
                (item) => item.toolId === toolId && item.statusId === statusId
            )
        },
        // setNumber(toolId, reference) {
        //     const index = this.shift.statuses.findIndex(
        //         item => item.toolId === toolId
        //     )
        //     const status =
        //         -1 !== index
        //             ? Object.assign({}, this.shift.statuses[index], {
        //                   reference,
        //               })
        //             : { toolId, reference }

        //     if (-1 === index) {
        //         this.shift.statuses.push(status)
        //     } else {
        //         this.shift.statuses.splice(index, 1, status)
        //     }
        // },
        setStatus(toolId, statusId) {
            const index = this.shift.statuses.findIndex(
                (item) => item.toolId === toolId
            )
            const status =
                -1 !== index
                    ? Object.assign({}, this.shift.statuses[index], {
                          statusId,
                      })
                    : { toolId, statusId }

            if (-1 === index) {
                this.shift.statuses.push(status)
            } else {
                this.shift.statuses.splice(index, 1, status)
            }
        },
        validateForm() {
            this.errors = []

            !this.theAccessPoint &&
                this.errors.push(
                    'Debe seleccionar un punto de acceso para iniciar el turno'
                )

            // Validar si se seleccionó el tipo de turno que se va a llevar a cabo
            !this.shift.vigilanceRol &&
                this.errors.push(
                    'Debe seleccionar el tipo de turno que va a realizar'
                )

            // Validar que se hayan contestado todos los estados de las herramientas
            ;(this.shift.statuses.length < this.items.length ||
                this.shift.statuses.filter((item) => !!item.statusId).length !==
                    this.items.length) &&
                this.errors.push(
                    'Debe diligenciar los estados de las herramientas'
                )

            // !!this.shift.statuses.filter(
            //     item => !item.reference || !item.reference.length
            // ).length &&
            //     this.errors.push(
            //         'Debe diligenciar los números de las herramientas'
            //     )

            // Validar que se hayan contestado todas las preguntas
            this.shift.answers.length < this.questions.length &&
                this.errors.push('Debe Contestar todas las preguntas')
            // Validar que se hayan escrito los comentarios de todas las herramientas que presenten defectos
            const issuedTools = this.shift.statuses.filter((item) =>
                this.dangerStatuses.includes(item.statusId)
            )

            issuedTools.length !==
                issuedTools.filter((item) => !!item.notes).length &&
                this.errors.push(
                    'Debe escribir las observaciones de todas las herramientas defectuosas'
                )

            return !this.errors.length
        },
        async startShift() {
            if (!this.validateForm()) return false

            this.$store.commit('accessPoint', this.theAccessPoint)

            const formData = new FormData()

            // rol del vigilante
            formData.append('vigilanceRolId', this.shift.vigilanceRol)

            // Pregutas y respuestas del checklist
            this.shift.answers.map((answer) => {
                formData.append('answers[question][]', answer.questionId)
                formData.append('answers[answer][]', answer.answerId)
            })

            // Estado de las herramientas
            this.shift.statuses.map((item) => {
                formData.append('items[item][]', item.toolId)
                formData.append('items[status][]', item.statusId)
                formData.append('items[reference][]', item.reference)
                formData.append(
                    'items[notes][]',
                    !!item.notes ? item.notes : ''
                )
            })

            // Enviar bandera si es inicio o entrega de turno
            const shiftAction = this.isStart ? 'start' : 'end'
            formData.append('shiftAction', shiftAction)
            if (shiftAction == 'end') {
                formData.append('openShiftId', this.$store.getters.shift.id)
            }

            formData.append('notes', this.shift.notes)
            const payload = {
                userId: this.user.id,
                structureId: this.accessPoint.id,
                data: formData,
            }

            shiftsRepository
                .startShift(this.accessPoint.id, this.user.id, formData)
                .then((shift) => {
                    this.$store.commit('shift', shift)
                    this.$store.dispatch('persistState')

                    if (this.isStart) {
                        // Ir a revisar el estado del sistema
                        this.$router.push({ name: 'generalStatus' })
                    } else {
                        toastr.success('Turno entregado Satisfactoriamente')
                        this.$store.dispatch('logOut')
                    }
                })
                .catch((error) =>
                    toastr.error(
                        'Ocurrió un error al intentar iniciar el turno'
                    )
                )
        },
        toolIssue(itemId) {
            const status = this.shift.statuses.find(
                (item) => item.toolId === itemId
            )
            return !!status && this.dangerStatuses.includes(status.statusId)
        },
    },
    created() {
        this.loadMasterData()
        this.theAccessPoint = this.accessPoint
    },
}
</script>
<style>
.should-fill {
    border: 1px solid #ef9a9a;
}
</style>
